<template>
  <div class="pepper-celebration">
    <div class="pepper-celebration-background">
      <lottie-player
        class="sunrise-player"
        :src="JSON.stringify(require('@/assets/animations/rising-sun'))"
        :autoplay="true"
        :preserveAspectRatio="'xMinYMax'"/>
    </div>
    <div class="pepper-celebration-container">
      <PepperCelebrationInternal :first-name="firstName" />
      <div class="footer">
        <single-click-button class="continue-button" title="להמשך החיבור" :action="next" :size="'small'"/>
        <share-button
          class="clickable"
          filename="riseup-pepper"
          share-name="riseupPepper"
          :share-component="shareComponent"
          :share-component-props="shareComponentProps"
          v-slot="slotProps">
          <div class="share-text" v-on:click="slotProps.onClick">
            <img :src="require('@/assets/share_white_icon.svg')">
            <div class="share-internal-text">לשתף עם חברים מפפר</div>
          </div>
        </share-button>
      </div>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import Segment from '@/Segment';
import SingleClickButton from '@/base-components/SingleClickButton';
import ShareButton from '@/base-components/share/ShareButton';
import PepperCelebrationInternal from './PepperCelebrationInternal';
import PepperCelebrationSharable from './PepperCelebrationSharable';

export default {
  components: {
    SingleClickButton,
    PepperCelebrationInternal,
    ShareButton,
  },
  name: 'PepperCelebration',
  created() {
    Segment.trackUserGot('PepperCelebrationPageEntered');
  },
  data() {
    return {
      shareComponent: PepperCelebrationSharable,
    };
  },
  computed: {
    ...mapGetters('session', ['firstName']),
    shareComponentProps() {
      return { firstName: this.firstName };
    },
  },
  methods: {
    ...mapActions('onboardingState', ['onboardingPageSubmit']),
    next() {
      this.onboardingPageSubmit();
    },
  },
};
</script>

<style lang="scss">
  @import '../../../../../../../node_modules/base-ui/src/scss/riseup-colors';

  .pepper-celebration {
    position: relative;

    .clickable {
      cursor: pointer;
    }

    .pepper-celebration-background {
      position: absolute;
      z-index: 1;
      width: 100%;
      height: 100%;
      background: #EB73EF;

      .sunrise-player {
        position: sticky;
        bottom: 0;
      }
    }

    .pepper-celebration-container {
      z-index: 2;
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow-y: scroll;

      .footer {
        flex-grow: 0;
        height: 300px;
        justify-content: center;
        padding: 60px 30px 20px;
        text-align: center;

        .continue-button {
          width: 100%;
          margin-bottom: 15px;
        }

        .share-text {
          clear: both;
          padding: 15px 0;
          margin: auto;
          color: white;
          font-size: 18px;
          font-weight: bold;

          img, div {
            display: inline;
            margin: 0 2px;
            vertical-align: middle;
          }
        }
      }
    }
  }
</style>
